module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Bold.8669b870.ttf";